// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"324": "b7d1c2a0","874": "a62e31a9",}[chunkId] + ".css"
}